<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-autocomplete
        :items="theClientes"
        :error-messages="errors"
        :value="value"
        :label="label"
        :prepend-icon="icon"
        :search-input.sync="search"
        item-text="trade_name"
        return-object
        @input="$emit('input', $event)"
        no-filter
        :multiple="multiple"
        @keyup="customChange($event, handleGetClientes)"
        :loading="calling"
      >
        <template v-slot:item="{ item, on, attrs }">
          <v-list-item v-bind="attrs" v-on="on" >
            <v-list-item-action v-if="multiple">
              <v-checkbox
               :input-value="attrs['aria-selected'] === 'true'"
                readonly
              />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.trade_name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ `CNPJ ${item.cnpj} - ${item.city} - ${item.district}` }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </validation-provider>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import ClientesApi from '@/services/tenants/clientes'
import { customChange } from '@/mixins/autocomplete.js'

export default {
  name: 'RelatorioCargaDescargaListFiltroModalItemInputCliente',
  mixins: [customChange],
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    value: {
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      ClientesSelecionados: [],
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual', 'user']),
    theClientes(){
      if(this.value){
        if(this.multiple){
          return [...this.value].concat(this.ClientesSelecionados.filter(c => !this.value.some(v => v.public_id === c.public_id)))
        }
        return [this.value].concat(this.ClientesSelecionados.filter(c => this.value.public_id != c.public_id))
      }
      return this.ClientesSelecionados
    }
  },
  methods: {
    async handleGetClientes(event) {
      const value = event.target.value
      await this.getClientesSearch({
        pesquisa: value,
      })
    },
    async getClientesSearch(parametros) {
      try {
        const clientes = await ClientesApi.getClientesSimple(
          this.empresaAtual.public_id,
          parametros
        )

        this.ClientesSelecionados = clientes.results
      } catch (e) {
        console.log(e)
        if (e.response.status === 404) {
          this.errorMessage('Página não encontrada')
        }
      }
    },
  },
}
</script>
